<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: null
        },
    },
    emits: ['update:modelValue'],
}
</script>

<template>
    <div class="general-checkbox general-checkbox--withLabel" v-if="label">
        <label class="general-checkbox__container">
            <input class="general-checkbox__input" type="checkbox" :checked="modelValue" @input="$emit('update:modelValue', $event.target.checked)" />
            <span class="general-checkbox__cross"></span>
        </label>
        <span class="general-checkbox__label" @click="$emit('update:modelValue', !modelValue)">{{label}}</span>
    </div>
    <label class="general-checkbox general-checkbox__container" v-else>
        <input type="checkbox" :checked="modelValue" @input="$emit('update:modelValue', $event.target.checked)" />
        <span class="general-checkbox__cross"></span>
    </label>
</template>

<style>
.general-checkbox span {
    cursor: pointer;
}

.general-checkbox--withLabel {
    display: flex;
    align-items: center;
}

.general-checkbox__container {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
}

.general-checkbox__input {
    opacity: 0;
    height: 0;
    width: 0;
}

.general-checkbox__label {
    user-select: none;
    display: inline-block;
    margin-left: 10px;
    font-size: 16px;
}

.general-checkbox__cross {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    border: 1px solid #121212;
    border-radius: 2px;
}

.general-checkbox__cross::before,
.general-checkbox__cross::after {
    position: absolute;
    content: "";
    background-color: #333333;
    display: none;
}

.general-checkbox__cross::before {
    height: 1.5px;
    width: 7px;
    left: 3.5px;
    top: 13.5px;
    transform: rotate(51.34deg);
}

.general-checkbox__cross::after {
    height: 1.5px;
    width: 15px;
    left: 5.5px;
    top: 10.5px;
    transform: rotate(126.87deg);
}

.general-checkbox__input:checked + .general-checkbox__cross::before,
.general-checkbox__input:checked + .general-checkbox__cross::after {
    display: block;
}
</style>